import { createSlice } from "@reduxjs/toolkit";
import { detailedCmt } from "../../data";

const initialState = {
  action: "insert",
  step: 0,

  contrNo: null,
  siteNo: null,
  apvNo: null,
  apvExpDate: null,

  IRBRASEQ: null,
  taskCodeListId: null,
  taskCodeId: null,
  status: null,
  submDate: null,
  rcptDate: null,
  apvDate: null,
  notiDate: null,
  detailedCmt: [],

  clinicalSiteSteps: [],

  PRT: null,
  PRTFilePath: null,
  IB: null,
  IBFilePath: null,
  pCRF: null,
  pCRFFilePath: null,
  eCRF: null,
  eCRFFilePath: null,
  ICF: null,
  ICFFilePath: null,
  // docs: [],
  otherDocs: [],

  costExclVAT: null,
  depDate: null,
  claim: null,
  comment: null,

  updateFields: [],
};

export const IRBSlice = createSlice({
  name: "IRB",
  initialState,
  reducers: {
    init: (state, action) => {
      return {
        ...initialState,
      };
    },

    updateAll: (state, action) => {
      return {
        ...action.payload,
        updateFields: [],
      };
    },

    updateAction: (state, action) => {
      return {
        ...state,
        action: action.payload.action,
      };
    },

    updateContrNo: (state, action) => {
      return {
        ...state,
        contrNo: action.payload.contrNo,
        updateFields: [...state.updateFields, "contrNo"],
      };
    },

    updateSiteNo: (state, action) => {
      return {
        ...state,
        siteNo: action.payload.siteNo,
        updateFields: [...state.updateFields, "siteNo"],
      };
    },

    updateApvNo: (state, action) => {
      return {
        ...state,
        apvNo: action.payload.apvNo,
        updateFields: [...state.updateFields, "apvNo"],
      };
    },

    updateApvExpDate: (state, action) => {
      return {
        ...state,
        apvExpDate: action.payload.apvExpDate,
        updateFields: [...state.updateFields, "apvExpDate"],
      };
    },

    updateIRBRASEQ: (state, action) => {
      return {
        ...state,
        IRBRASEQ: action.payload.IRBRASEQ,
        updateFields: [...state.updateFields, "IRBRASEQ"],
      };
    },

    updateTaskCodeListId: (state, action) => {
      return {
        ...state,
        taskCodeListId: action.payload.taskCodeListId,
        updateFields: [...state.updateFields, "taskCodeListId"],
      };
    },

    updateTaskCodeId: (state, action) => {
      return {
        ...state,
        taskCodeId: action.payload.taskCodeId,
        updateFields: [...state.updateFields, "taskCodeId"],
      };
    },

    updateStatus: (state, action) => {
      return {
        ...state,
        status: action.payload.status,
        updateFields: [...state.updateFields, "status"],
      };
    },

    updateSubmDate: (state, action) => {
      return {
        ...state,
        submDate: action.payload.submDate,
        updateFields: [...state.updateFields, "submDate"],
      };
    },

    updateRcptDate: (state, action) => {
      return {
        ...state,
        rcptDate: action.payload.rcptDate,
        updateFields: [...state.updateFields, "rcptDate"],
      };
    },

    updateApvDate: (state, action) => {
      return {
        ...state,
        apvDate: action.payload.apvDate,
        updateFields: [...state.updateFields, "apvDate"],
      };
    },

    updateNotiDate: (state, action) => {
      return {
        ...state,
        notiDate: action.payload.notiDate,
        updateFields: [...state.updateFields, "notiDate"],
      };
    },

    updatePRT: (state, action) => {
      return {
        ...state,
        PRT: action.payload.PRT,
        updateFields: [...state.updateFields, "PRT"],
      };
    },

    updateIB: (state, action) => {
      return {
        ...state,
        IB: action.payload.IB,
        updateFields: [...state.updateFields, "IB"],
      };
    },

    updatePCRF: (state, action) => {
      return {
        ...state,
        pCRF: action.payload.pCRF,
        updateFields: [...state.updateFields, "pCRF"],
      };
    },

    updateECRF: (state, action) => {
      return {
        ...state,
        eCRF: action.payload.eCRF,
        updateFields: [...state.updateFields, "eCRF"],
      };
    },

    updateICF: (state, action) => {
      return {
        ...state,
        ICF: action.payload.ICF,
        updateFields: [...state.updateFields, "ICF"],
      };
    },

    updateComment: (state, action) => {
      return {
        ...state,
        comment: action.payload.comment,
        updateFields: [...state.updateFields, "comment"],
      };
    },

    updatePRTFilePath: (state, action) => {
      return {
        ...state,
        PRTFilePath: action.payload.PRTFilePath,
        updateFields: [...state.updateFields, "PRTFilePath"],
      };
    },

    updateIBFilePath: (state, action) => {
      return {
        ...state,
        IBFilePath: action.payload.IBFilePath,
        updateFields: [...state.updateFields, "IBFilePath"],
      };
    },

    updatePCRFFilePath: (state, action) => {
      return {
        ...state,
        pCRFFilePath: action.payload.pCRFFilePath,
        updateFields: [...state.updateFields, "pCRFFilePath"],
      };
    },

    updateECRFFilePath: (state, action) => {
      return {
        ...state,
        eCRFFilePath: action.payload.eCRFFilePath,
        updateFields: [...state.updateFields, "eCRFFilePath"],
      };
    },

    updateICFFilePath: (state, action) => {
      return {
        ...state,
        ICFFilePath: action.payload.ICFFilePath,
        updateFields: [...state.updateFields, "ICFFilePath"],
      };
    },

    updateStep: (state, action) => {
      return { ...state, step: action.payload.step };
    },

    updateDocs: (state, action) => {
      // return {
      //   ...state,
      //   docs: {
      //     ...state.docs,
      //     [action.payload.docs.title]: action.payload.docs.filePath,
      //   },
      // };

      let update = false;

      const docs = state.docs.map((docs) => {
        if (docs.title == action.payload.docs.title) {
          update = true;

          return {
            ...docs,
            ...action.payload.docs,
          };
        }

        return docs;
      });

      return {
        ...state,
        docs: update ? docs : [...state.docs, action.payload.docs],
        updateFields: [...state.updateFields, "docs"],

        // docs: [...state.docs, action.payload.docs],
      };
    },

    updateCostExclVAT: (state, action) => {
      return {
        ...state,
        costExclVAT: action.payload.costExclVAT,
        updateFields: [...state.updateFields, "costExclVAT"],
      };
    },

    updateDepDate: (state, action) => {
      return {
        ...state,
        depDate: action.payload.depDate,
        updateFields: [...state.updateFields, "depDate"],
      };
    },

    updateClaim: (state, action) => {
      return {
        ...state,
        claim: action.payload.claim,
        updateFields: [...state.updateFields, "claim"],
      };
    },

    ///

    addDetailedCmt: (state, action) => {
      const SEQ = state.detailedCmt.reduce((SEQ, detailedCmt) => {
        return detailedCmt.SEQ > SEQ ? detailedCmt.SEQ : SEQ;
      }, 0);

      action.payload.detailedCmt.SEQ = SEQ + 1;

      return {
        ...state,
        detailedCmt: [...state.detailedCmt, action.payload.detailedCmt],
        updateFields: [...state.updateFields, "detailedCmt"],
      };
    },

    removeDetailedCmt: (state, action) => {
      return {
        ...state,
        detailedCmt: state.detailedCmt.filter(
          (detailedCmt) => detailedCmt.SEQ != action.payload.detailedCmt.SEQ
        ),
        updateFields: [...state.updateFields, "detailedCmt"],
      };
    },

    updateDetailedCmt: (state, action) => {
      return {
        ...state,
        detailedCmt: state.detailedCmt.map((detailedCmt) => {
          // Check if the user ID matches the one you want to update
          if (detailedCmt.SEQ === action.payload.detailedCmt.SEQ) {
            // Return a new object with the updated name
            return { ...detailedCmt, ...action.payload.detailedCmt };
          }
          // Return the original user object if no change is needed
          return detailedCmt;
        }),
        updateFields: [...state.updateFields, "detailedCmt"],
      };
    },

    addClinicalSiteSteps: (state, action) => {
      return {
        ...state,
        clinicalSiteSteps: [
          ...state.clinicalSiteSteps,
          action.payload.clinicalSiteSteps,
        ],
        updateFields: [...state.updateFields, "clinicalSiteSteps"],
      };
    },

    removeClinicalSiteSteps: (state, action) => {
      return {
        ...state,
        clinicalSiteSteps: state.clinicalSiteSteps.filter(
          (clinicalSiteSteps) =>
            clinicalSiteSteps.type != action.payload.clinicalSiteSteps.type &&
            clinicalSiteSteps.name != action.payload.clinicalSiteSteps.name
        ),
        updateFields: [...state.updateFields, "clinicalSiteSteps"],
      };
    },

    updateClinicalSiteSteps: (state, action) => {
      return {
        ...state,
        clinicalSiteSteps: state.clinicalSiteSteps.map((clinicalSiteSteps) => {
          if (
            clinicalSiteSteps.type ==
              action.payload.preClinicalSiteSteps.type &&
            clinicalSiteSteps.name == action.payload.preClinicalSiteSteps.name
          ) {
            return {
              ...clinicalSiteSteps,
              ...action.payload.clinicalSiteSteps,
            };
          }

          return clinicalSiteSteps;
        }),
        updateFields: [...state.updateFields, "clinicalSiteSteps"],
      };
    },

    addOtherDocs: (state, action) => {
      return {
        ...state,
        otherDocs: [...state.otherDocs, action.payload.otherDocs],
        updateFields: [...state.updateFields, "addOtherDocs"],
      };
    },

    removeOtherDocs: (state, action) => {
      return {
        ...state,
        otherDocs: state.otherDocs.filter(
          (otherDocs) => otherDocs.title != action.payload.otherDocs.title
        ),
        updateFields: [...state.updateFields, "addOtherDocs"],
      };
    },

    updateOtherDocs: (state, action) => {
      return {
        ...state,
        otherDocs: state.otherDocs.map((otherDocs) => {
          if (otherDocs.title == action.payload.otherDocs.key) {
            return {
              ...otherDocs,
              ...action.payload.otherDocs,
            };
          }

          return otherDocs;
        }),
        updateFields: [...state.updateFields, "otherDocs"],
      };
    },
  },
});

export const {
  init,
  updateAll,
  updateAction,
  updateContrNo,
  updateSiteNo,
  updateApvNo,
  updateApvExpDate,
  updateIRBRASEQ,
  updateTaskCodeListId,
  updateTaskCodeId,
  updateStatus,
  updateSubmDate,
  updateRcptDate,
  updateApvDate,
  updateNotiDate,
  updateDetailedCmt,
  updateClinicalSiteSteps,
  updatePRT,
  updateIB,
  updatePCRF,
  updateECRF,
  updateICF,
  updateDocs,
  updateOtherDocs,
  updateCostExclVAT,
  updateDepDate,
  updateClaim,
  updateComment,
  updatePRTFilePath,
  updateIBFilePath,
  updatePCRFFilePath,
  updateECRFFilePath,
  updateICFFilePath,
  updateStep,
  addDetailedCmt,
  addClinicalSiteSteps,
  addOtherDocs,
  removeDetailedCmt,
  removeClinicalSiteSteps,
  removeOtherDocs,
} = IRBSlice.actions;

export default IRBSlice.reducer;
